<div class="col-md-12 m-b30">
  <h1 class="m-b20 m-t0">Autenticación</h1>
  <div class="col-md-3 m-b30"></div>
  <div class="col-md-6 m-b30">
    <form action="your-action" (submit)="onFormSubmit($event)">
      <div class="dx-fieldset">
          <div class="dx-field">
            <span>Usuario:</span>
              <div>
                  <dx-text-box
                  [(value)]="username"> 
                      <dx-validator>
                          <dxi-validation-rule type="required" message="El campo usuario es requerido"></dxi-validation-rule>
                      </dx-validator>
                  </dx-text-box>
              </div>
          </div>
          <div class="dx-field">
            <span>Contraseña:</span>
              <div>
                  <dx-text-box
                      mode="password"
                      [(value)]="password">
                      <dx-validator>
                          <dxi-validation-rule type="required" message="El campo contraseña es requerido"></dxi-validation-rule>
                      </dx-validator>
                  </dx-text-box>
              </div>
          </div>
      </div> 
      <div class="dx-fieldset">
          <dx-validation-summary id="summary"></dx-validation-summary>
          <div style="float: right;">
            <dx-button 
            id="button"
            text="Aceptar"  
            [useSubmitBehavior]="true">
            <div *dxTemplate="let data of 'content'">
              <dx-load-indicator class='button-indicator'
                  [visible]="loadIndicatorVisible">
              </dx-load-indicator>
              <span class='dx-button-text'>Aceptar</span>
          </div>
        </dx-button>
          </div>
      </div>
    </form>
  </div>
  <div class="col-md-3 m-b30"></div>
</div>




// WEBPACK FOOTER //
// ./src/app/pages/report/auth/auth.component.html